var _GlobalLocalObj = new GlobalLocalObjCanada();
function GlobalLocalObjCanada()
{
	var strMonthShort = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
	var strMonthFull = new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
	var strMonthFullF = new Array("janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre");
	// public function
	this.localName =  "ca";
	this.errDateHelpText= "Invalid date format.  Please enter as 31/JAN/2005 or select from calendar.";
	this.printShortMonth =   strMonthShort;
	this.printLongMonth =   strMonthFull;
	this.printLongMonthF =   strMonthFullF;

}

export const convertFrom24To12Format = (time24: string) => {
    const [sHours, minutes] = time24.match(/([0-9]{1,2}):([0-9]{2})/).slice(1);
    const period = +sHours < 12 ? 'AM' : 'PM';
    const hours = +sHours % 12 || 12;
    return `${hours}:${minutes} ${period}`;
}


export const convertTime12to24 = (time12h) => {
    const [time, modifier] = time12h.split(' ');
    let [hours, minutes] = time.split(':');
    if (hours === '12') { hours = '00' }
    if (modifier === 'PM') { hours = parseInt(hours, 10) + 12 }
    return `${hours}:${minutes}`;
}


export const getCurentDateTime = (): string => {
    let ts = Date.now();
    const currentDateTime = new Date(ts);
    const formatedCurrentDateTime = currentDateTime.toLocaleString();

    return formatedCurrentDateTime;
};

export function daysElapsed(date1:Date,date2:Date) :number
{
    let difference = Date.UTC(y2k(date1.getFullYear()),date1.getMonth(),date1.getDate(),0,0,0) - Date.UTC(y2k(date2.getFullYear()),date2.getMonth(),date2.getDate(),0,0,0);
    return difference/1000/60/60/24;
}

export function y2k(number:number) :number
{ 
	return (number < 1000) ? number + 1900 : number; 
}

export function isXMLDate(date: string): boolean {
	const regex = /^\d{4}-\d{2}-\d{2}$/;
	if (date.match(regex)) {
		return true;
	}
	return false;
}

export function differenceInDays(from:string, to:string):number
{
	if (to && to !== '' && from && from !== '')
	{
		var toDate = xmlDateToDate(to);
		var fromDate = xmlDateToDate(from);
		if (toDate && fromDate)
		{
			var numOfDays =  Date.UTC(y2k(toDate.getFullYear()),toDate.getMonth(),toDate.getDate(),0,0,0) - Date.UTC(y2k(fromDate.getFullYear()),fromDate.getMonth(),fromDate.getDate(),0,0,0);
			numOfDays = (numOfDays/1000/60/60/24);
			return numOfDays;
		}
	}
	return 0;
}

export function dateToXMLDate(dt:Date):string
{
	var s = "";
	if (dt != null)
	{
	//	var singleDigittext= new Array("01","02","03","04","05","06","07","08","09");
		s = "";
		s +=dt.getFullYear();
		s+= "-";
		if (dt.getMonth() < 9)
			s+= "0"+(dt.getMonth()+1);
		else
			s+=	dt.getMonth()+1;
		s+= "-";
		if (dt.getDate() <10)
			s+= "0"+dt.getDate();
		else
			s+=	dt.getDate();
	}		
	return s;	
}

export function xmlDateToDateText(v:string):string
{
	return FormatDateDataType(v, "");
}
	
export function xmlDateToDate(v:string):Date
{

	if((v == null) ||(v === ""))
		return null;
	var a = v.split("-",3);
	if (a.length !== 3)
	{
		return null;
	}
	else
	{
		var daysInMonth = new Array(31,29,31,30,31,30,31,31,30,31,30,31);

		if (a[1].substr(0,1) === "0")
			a[1] =	a[1].substr(1);
		if (a[2].substr(0,1) === "0")
			a[2] =	a[2].substr(1);
		var d = parseInt(a[2]);
		var m = parseInt(a[1]);
		var y = parseInt(a[0]);
		if (!isNaN(m) && m >0 && m < 13)
		{
			m--;
			if (!isNaN(y) &&  y > 1000 && y < 3000)
				if (!isNaN(d) && d > 0 && d <= daysInMonth[m])
					if (m !== 1 || ( d <= (((y % 4 === 0) && ( (!(y % 100 === 0)) || (y % 400 === 0) ) ) ? 29 : 28 )))
						return (new Date(y,m,d));
		}				
	}
}

export function FormatDateDataType(value:string, format:string):string
{
	var dayoffset = 0;	//should only be used for merging docs, so it's not editable, otherwise it'll update xml data
	if (value == null) return;
	if(format > "")
	{
		var posOff = format.indexOf(";");
		if(posOff !== -1)
		{
			dayoffset = parseInt(format.substr(posOff+1));
			format = format.substr(0, posOff);
		}
	}
	var retVal:string = value;		//xml format is 2003-02-18, which is not recognized by Date() object in JScript
	var iDate = null;
		
	var arrNum = retVal.split("/",3);
	if (arrNum.length===3 && arrNum[0].length===2 && arrNum[1].length===3 && arrNum[2].length===4)
		iDate = new Date(MonthNumOf(arrNum[1])+"/"+arrNum[0]+"/"+arrNum[2]);
	if (iDate == null || isNaN(iDate))
		iDate = xmlDateToDate(value);
	if (iDate == null || isNaN(iDate))
		return "";
	if( typeof(iDate) != "object" )
		return iDate;	//iDate is "" or "Err"
	if(dayoffset !== 0)
	{
		iDate = new Date(iDate.valueOf() + dayoffset * 24 * 60 * 60 * 1000);
	}
	if ( typeof(format) == "undefined" || format === "" || format == null || format === "null" )
	{
		format = "df"+_GlobalLocalObj.localName;
	}
	switch(format)
	{
	case "df0":
		retVal = iDate.getDate() + "/" + MonthOf(iDate.getMonth(), true) + "/" + iDate.getFullYear();
		break;
	case "df1":
		retVal = MonthOf(iDate.getMonth()) + " " + iDate.getDate() + ", " + iDate.getFullYear();
		break;
	case "df2":
		retVal = DayOf(iDate.getDay()) + ", " + MonthOf(iDate.getMonth()) + " " + iDate.getDate() + ", " + iDate.getFullYear();
		break;
	case "df3":
		retVal = iDate.getDate() + " " + MonthOf(iDate.getMonth()) + " " + iDate.getFullYear();
		break;
	case "df4":
	case "dfus":
		retVal = (iDate.getMonth()+1) + "/" + iDate.getDate() + "/" + iDate.getFullYear();
		break;
	case "df5":
		retVal = (iDate.getMonth()+1) + "/" + iDate.getDate() + "/" + String(iDate.getFullYear()).substring(2);
		break;
	case "df6":
		retVal = iDate.getFullYear() + "-" + (iDate.getMonth()+1) + "-" + iDate.getDate();
		break;
	case "df7":
		retVal = iDate.getDate() + "-" + MonthOf(iDate.getMonth()) + "-" + String(iDate.getFullYear()).substring(2);
		break;
	case "df6w0":
		retVal = iDate.getFullYear() + "-";
		var tmpVal = iDate.getMonth()+1;
		if(tmpVal < 10) tmpVal="0"+tmpVal;
		retVal += tmpVal +"-";
		tmpVal = iDate.getDate();
		if(tmpVal < 10) tmpVal="0"+tmpVal;
		retVal += tmpVal;
		break;
	case "dfy":
		retVal = iDate.getFullYear();
		break;
	case "dfm":
		retVal = iDate.getMonth()+1;
		break;
	case "dfm0":
		retVal = iDate.getMonth()+1;
		if(parseInt(retVal) < 10)
		retVal="0"+retVal;
		break;
	case "dfmth":
		retVal = MonthOf(iDate.getMonth());
		break;
	case "dfmthf":
		retVal = MonthOf(iDate.getMonth(), null, "dfmthf");
		break;
	case "dfd":
		retVal = iDate.getDate();
		break;
	case "dfd0":
		retVal = iDate.getDate();
		if(parseInt(retVal) < 10)
		retVal="0"+retVal;
		break;
	case "dfdFinal":
		var DateMonth = iDate.getMonth()+1;
		var DateYear = iDate.getFullYear();
		switch(DateMonth)
		{
		case 2:
			if((DateYear%4 === 0 && DateYear%100 !== 0) || DateYear%400 === 0)
				retVal = "29";
			else	
				retVal = "28";
			break;
		case 4:
		case 6:
		case 9:
		case 11:
			retVal = "30";
			break;
		default:
			retVal = "31";
			break;
		}
		break;
	case "dfday":
		retVal = DayOfFull(iDate.getDate()-1);
		break;
	case "df8":
	case "dfqc":
	case "asis":
		retVal = value;	//as is xml date
		break;
	case "df9":
		retVal = DayOfFull(iDate.getDate()-1) + " day of  " + MonthOf(iDate.getMonth()) + ", " + iDate.getFullYear();
		break;
	case "dfca":	
		retVal = (iDate.getDate()>9?"":"0")+iDate.getDate() + "/" + MonthOf(iDate.getMonth(), true).toUpperCase() + "/" + iDate.getFullYear();
		break;
	case "df10":
		retVal = iDate.getFullYear() + "-";
		if (iDate.getMonth()+1 < 10) 
			retVal += "0";
		retVal = retVal + (iDate.getMonth()+1) + "-";
		if (iDate.getDate() < 10)
			retVal += "0";
		retVal += iDate.getDate();
		break;
	default:
		retVal = "no such format code : (" + format+")";			
		break;
	}
	return retVal;
}

function DayOfFull(d:number, bShort:boolean=false):string
{
	if(bShort == null)
		bShort = false;	
	var strDayFullShort = new Array("01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31");
	var strDayFullFull = new Array("1st", "2nd", "3rd", "4th", "5th", "6th", 
						"7th", "8th", "9th", "10th", "11th", "12th", "13th", "14th", "15th", "16th", "17th", "18th", 
						"19th", "20th", "21st", "22nd", "23rd", "24th", "25th", "26th", "27th", "28th", "29th", "30th", "31st");
	var strDayFullFull2 = new Array("first", "second", "third", "fourth", "fifth", "sixth", 
						"seventh", "eighth", "ninth", "tenth", "eleventh", "twelfth", "thirteenth", "fourteenth", "fifteenth", "sixteenth", "seventeenth", "eighteenth", 
						"nineteenth", "twentieth", "twenty-first", "twenty-second", "twenty-third", "twenty-fourth", "twenty-fifth", "twenty-sixth", "twenty-seventh", "twenty-eighth", "twenty-ninth", "thirtieth", "thirty-first");
	var strDayOfFull = bShort? strDayFullShort[d] : strDayFullFull[d];
	return strDayOfFull;
}

function MonthOf(m:number, bShort:boolean=false, monthformat:string=null):string
{
	if(bShort == null)
		bShort = false;	//default: whole name
	var strMonthShort = _GlobalLocalObj.printShortMonth;
	var strMonthFull;
	if(monthformat === "dfmthf")
		strMonthFull =	_GlobalLocalObj.printLongMonthF;
	else
		strMonthFull =	_GlobalLocalObj.printLongMonth;
	var strMon = bShort? strMonthShort[m] : strMonthFull[m];
	return strMon;
}

function MonthNumOf(str:string):string
{
	var strMonthFull = _GlobalLocalObj.printLongMonth;
	var i = 0;
	for (i=0; i<strMonthFull.length; i++)
	{
		if(strMonthFull[i].toUpperCase().indexOf(str.toUpperCase()) == 0)
			break;
	}
	++i;	//make i: 1,2,3,4,...,11,12
	return i<10? "0"+i : ""+i;
}

function DayOf(d:number, bShort:boolean=false):string
{
	if(bShort == null)
		bShort = false;	//default: whole name
	var strDayShort = new Array("Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat");
	var strDayFull = new Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday");
	var strDay = bShort? strDayShort[d] : strDayFull[d];
	return strDay;
}

function DayOfFr(d:number, bShort:boolean):string {
	if (bShort == null)
		bShort = false; //default: whole name
	var strDayShort = new Array("dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam.");
	var strDayFull = new Array("dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi");
	var strDay = bShort ? strDayShort[d] : strDayFull[d];
	return strDay;
}